import { render, staticRenderFns } from "./ApptReceipt.vue?vue&type=template&id=55621aa8&scoped=true"
import script from "./ApptReceipt.vue?vue&type=script&lang=js"
export * from "./ApptReceipt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55621aa8",
  null
  
)

export default component.exports